import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import api_requests from "../../store/api/api_requests";
import axios from "axios";

export default {
    name: 'Cropper',
    components: {
        VueCropper
    },
    data() {
        return {
            flag: false,
            imgSrc: '',
            cropImg: '',
            data: null,
            image: '',
            image_name: '',
            image_size: '',
        };
    },
    props: ['show', 'uploadedImg'],
    methods: {
        cropImage() {
            return new Promise((resolve, reject) => {
                // get image data for post processing, e.g. upload or setting image src
                this.$refs.cropper.getCroppedCanvas({width: 1280, height: 720}).toBlob((blob) => {
                    let data = new FormData();
                    data.append('img', blob, 'cropped.png')
                    axios.post(process.env.VUE_APP_API + '/image/upload', data, {
                        headers: {
                            'Authorization': localStorage.getItem('token'),
                            'Content-Type': 'multipart/form-data'
                        }}
                    ).then(response => {
                        this.image = response.data.path
                        resolve();
                    }).catch(error => {
                        console.log(error)
                        reject()
                    })
                })

            })
        },
        reset() {
            this.$refs.cropper.reset();
        },
        rotate(deg) {
            this.$refs.cropper.rotate(deg);
        },
        setCropBoxData() {
            if (!this.data) return;
            this.$refs.cropper.setCropBoxData(JSON.parse(this.data));
        },
        setData() {
            if (!this.data) return;
            this.$refs.cropper.setData(JSON.parse(this.data));
        },
        setImage(e) {
            const file = e.target.files[0];
            if (file.type.indexOf('image/') === -1) {
                alert('Please select an image file');
                return;
            }
            if (typeof FileReader === 'function') {
                const reader = new FileReader();
                reader.onload = (event) => {
                    this.imgSrc = event.target.result;
                    this.$refs.cropper.replace(event.target.result);
                };
                reader.readAsDataURL(file);
            } else {
                alert('Sorry, FileReader API not supported');
            }
        },
        showFileChooser() {
            this.$refs.input.click();
        },
    },
    mounted() {
        // if (localStorage.image) {
        //     this.image = localStorage.image;
        // }
        // if (localStorage.image_name) {
        //     this.image_name = localStorage.image_name;
        // }
        // if (localStorage.image_size) {
        //     this.image_size = localStorage.image_size;
        // }
    },
    computed: {

    },
    watch: {
        image(newImage) {
            this.$emit('cover', newImage)
            localStorage.image = newImage;
        },
        image_name(newImage) {
            localStorage.image_name = newImage;
        },
        image_size(newImage) {
            localStorage.image_size = newImage;
        }
    },
    created() {
        this.imgSrc = (this.uploadedImg) ? this.uploadedImg : '/img/img-test-cropper.png'
    }
};
